import { PaymentType } from '@allesauto/graphql';
import translate from '@allesauto/i18n';
import { formatPrice } from '@allesauto/utils/funcs';
import * as React from 'react';
import { useIntl } from 'react-intl';

interface FooterPriceProps {
  paymentType: PaymentType;
  amount: number;
  customText?: string;
}

export default function OverlayFooterPrice({
  paymentType,
  amount,
  customText,
}: FooterPriceProps) {
  const intl = useIntl();

  const className = {
    wrappper:
      'flex items-center justify-between md:flex-col-reverse md:items-start md:justify-start md:px-60px pb-10px md:pb-0',
    paymentType: 'text-white monochrome:!text-white',
    priceLine: 'flex items-center',
    monthlyRate:
      'text-green60 monochrome:text-white mr-3px md:mr-5px font-weight-bold font-regular text-[8px] md:text-[10px] w-20px md:leading-[11px] leading-[10px]',
    amount: 'font-headline text-green60 monochrome:!text-white text-headline3',
    legal: 'text-white monochrome:!text-white text-legal ml-5px self-start',
  };

  return (
    <div className={className.wrappper}>
      <div className={className.paymentType} id="label--payment-type">
        {customText ? (
          customText
        ) : (
          <>
            {paymentType === PaymentType.CashRange &&
              translate(intl, 'ui.PAYMENT_OPTIONS.CASH.FOOTER_TEXT')}
            {paymentType === PaymentType.LeasingRateRange &&
              translate(intl, 'ui.PAYMENT_OPTIONS.LEASING_FORM.FOOTER_TEXT')}
            {paymentType === PaymentType.LoanRateRange &&
              translate(intl, 'ui.PAYMENT_OPTIONS.FINANCING_FORM.FOOTER_TEXT')}
          </>
        )}
      </div>
      <div className={className.priceLine}>
        {paymentType !== PaymentType.CashRange && (
          <div className={className.monthlyRate} id="label--price">
            {translate(intl, 'ui.PDP.FOOTER.LABEL_TOTAL_PRICE')}
          </div>
        )}
        <div className={className.amount} id="label--price-value">
          {formatPrice(intl, amount, {
            withFractionDigits: true,
          })}
        </div>
        {paymentType !== PaymentType.CashRange && (
          <div className={className.legal} id="label--price-value">
            1
          </div>
        )}
      </div>
    </div>
  );
}
